export default "__VITE_ASSET__DONixz82__"